import { Component, OnInit, OnDestroy, ViewChild, ElementRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AvailabilityService,
  ProductService,
  AuthService,
  PriceService,
  MetadataService,
  BaseDetailData,
  Product,
  GungFlowService,
  PriceConfigService,
  AssortmentService,
  BaseViewConfigService
} from 'gung-standard';
import { JeevesProductDetailsComponent } from 'gung-standard-jeeves';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Observable, of, Subscription } from 'rxjs';
import { ColmecCustomerProductPrice } from '../../models/colmec-price';

@Component({
    selector: 'colmec-product-details',
    templateUrl: './colmec-product-details.component.html',
    styleUrls: ['./colmec-product-details.component.scss'],
    standalone: false
})
export class ColmecProductDetailsComponent extends JeevesProductDetailsComponent implements OnInit, OnDestroy {  protected translateService = inject(TranslateService);
  protected metadataService = inject(MetadataService);
  protected priceConfigService = inject(PriceConfigService);

  public imageIdString = 'productImage';
  @ViewChild(NgbCarousel)
  private myCarousel: NgbCarousel;
  @ViewChild('scrollContainer')
  scrollingImages: ElementRef;

  private langeChangeEvent: Subscription;
  public hidePrice = false;

  currentLang = this.translateService.currentLang || 'se';

  protected handleObservable(observable: Observable<BaseDetailData>): void {
    observable.subscribe(d => {
      const { product, availability, price } = d;
      if (product.extra.pim && product.extra.pim.accessories) {
        this.addonIds = product.extra.pim.accessories.split(',');
      }
      if (product.extra.pim && product.extra.pim.relatedProducts) {
        this.pimRelatedProductsIds = product.extra.pim.relatedProducts.split(',');
      }
      this.product = product;
      this.availability = availability;
      this.price = price;
    });
  }

  ngOnInit() {
    super.ngOnInit();

    this.langeChangeEvent = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getProductDescription();
    });

    this.priceConfigService.hidePrice.subscribe(hidePrice => (this.hidePrice = hidePrice));
  }

  select(index: number): void {
    this.myCarousel.select(this.imageIdString + index);
  }

  scrollImagesRight(): void {
    const scroller = this.scrollingImages.nativeElement as HTMLElement;
    const scrollWidth = Math.min(
      scroller.scrollLeft + scroller.clientWidth,
      scroller.scrollWidth - scroller.clientWidth
    );
    scroller.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
  }

  scrollImagesLeft(): void {
    const scroller = this.scrollingImages.nativeElement as HTMLElement;
    const scrollWidth = Math.max(scroller.scrollLeft - scroller.clientWidth, 0);
    scroller.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    if (this.langeChangeEvent) {
      this.langeChangeEvent.unsubscribe();
    }
  }

  getBooleanName(value: boolean): string {
    if (value) {
      return this.translateService.instant('YES');
    }
    return this.translateService.instant('NO');
  }

  getOptionName(table: string, value: string, key: string): string {
    const result = this.metadataService.getMetadataValue(table, value, key);
    if (result) {
      return result;
    }
    return '';
  }

  getProductDescription(): Observable<string> {
    const lang = this.translateService.currentLang || 'se';

    let description = '';
    if (this.product.extra.i18n && this.product.extra.i18n[lang]) {
      description = this.product.extra.i18n[lang].description || '';
    }
    return of(description);
  }

  getNetPriceLabel(product: Product): Observable<string> {
    if (!product) {
      return of('');
    }

    if (product.extra.ar.varugruppkod === '10') {
      return of(this.translateService.instant('NET_PRICE_INC_FRAME'));
    }

    return of(this.translateService.instant('NET_PRICE'));
  }

  getNetPriceValue(price: ColmecCustomerProductPrice): number {
    if (price.priceInclAutoAdded) {
      return price.priceInclAutoAdded.value;
    }

    return price.customerNetPrice.value;
  }
}
